import React from "react";
import { Row, Col } from "react-bootstrap";
import PasswordResetForm from "./component/PasswordResetForm/PasswordResetForm";
import EmailImage from "../Reset/components/ResetImage";

const PasswordReset = () => {
  return (
    <>
      <div className="wrapper">
        <div className="h-100 vh-100">
          <Row>
            <Col lg={6}>
              <PasswordResetForm />
            </Col>
            <Col lg={6}>
              <EmailImage />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default PasswordReset;
